





















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import IAuthentication from '@/store/models/IAuthentication';
import IOutbound from '@/store/models/IOutbound';
import OutboundApi from '@/store/api/OutboundApi';
import OutboundPictureApi from '../store/api/OutboundPictureApi';
import IInbound from '@/store/models/IInbound';
import InboundApi from '../store/api/InboundApi';
import InboundPictureApi from '../store/api/InboundPictureApi';
import UploadServiceApi from '../store/api/UploadServiceApi';
import IBlob from '@/store/models/IBlob';
import IInboundPicture from '../store/models/IInboundPicture';
import IOutboundPicture from '../store/models/IOutboundPicture';
import Snackbar from '@/components/shared/Snackbar.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vue2Dropzone from 'vue2-dropzone';
import { v4 as uuidv4 } from 'uuid';
@Component({
    components: {
        Snackbar,
        vueDropzone: vue2Dropzone
    }
})
export default class UploadFotos extends Vue {
    step: number = 1;
    inboundSelected : IInbound = {} as IInbound;
    inboundList: IInbound[] = [];
    outboundSelected : IOutbound = {} as IOutbound;
    outboundList: IOutbound[] = [];
    inboundApi : InboundApi;
    outboundApi : OutboundApi;
    uploadServiceApi : UploadServiceApi;
    inboundPictureApi : InboundPictureApi;
    outboundPictureApi : OutboundPictureApi;
    overlay: boolean = false;
    BlobsSource: IBlob[] = [];
    BlobsDestination: IBlob[] = [];
    inboundPictures : IInboundPicture[] = [];
    outboundPictures : IOutboundPicture[] = [];
    currFiles: any[] = [];
    files: any[] = [];
    dropzoneOptions: any = {
        autoProcessQueue: false,
        url: 'http://localhost',
        thumbnailWidth: 100,
        maxFilesize: 25,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG,.GIF",
        maxFiles: 10,
        previewsContainer: false
    };
    companyId : string = "";
    radios: any = null;

    constructor() {
        super();
        this.inboundApi = new InboundApi();
        this.uploadServiceApi = new UploadServiceApi("Inbounds");
        this.inboundPictureApi = new InboundPictureApi("Inbounds");
        this.outboundApi = new OutboundApi();
        this.outboundPictureApi = new OutboundPictureApi("Outbounds");
    }
    
    created() {
        this.getPermissions();
        this.getInbounds();
        this.getOutbounds();
    }

    getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
    }

    @Watch('radios')
    onChangeRadios() {
        this.inboundSelected = {} as IInbound;
        this.outboundSelected = {} as IOutbound;
        this.inboundPictures = [];
        this.outboundPictures = [];
        this.files = [];
        this.currFiles = [];
    }

    @Watch('inboundSelected')
    onChangeInboundSelected() {
        this.files = [];
        this.currFiles = [];
    }

    @Watch('outboundSelected')
    onChangeOutboundSelected() {
        // this.outboundPictures = [];
        this.files = [];
        this.currFiles = [];
    }

    showUploadFotos() {
        if (this.inboundSelected !== undefined && Object.keys(this.inboundSelected).length !== 0) return true;
        if (this.outboundSelected !== undefined && Object.keys(this.outboundSelected).length !== 0) return true;
        return false;
    }

    appendLocation(file: any, xhr: any, formData: FormData) {
        this.overlay = true;
        this.files.push(file);
        this.overlay = false;
    }

    removeFile(file: any) {
        let index = this.files.findIndex(f => f.name === file.name);
        if (index !== -1) {
            this.remove(index);
        }
    }
    
    onMaxFilesReached(files: any[]) {
        this.showMessageWarning("A maximum of 10 files may be uploaded.");
        if (files.length > 10) {
            files.slice(10).forEach((file) => {
                this.removeFile(file);
            });
        }
    }

    remove(index: number) {
        this.files.splice(index, 1);
    }

    async uploadFiles() {
        if (!this.files) {
            this.showMessageWarning("Please select a picture");
        } else {
            if ((this.inboundSelected === undefined && Object.keys(this.inboundSelected).length === 0) || (this.outboundSelected === undefined && Object.keys(this.outboundSelected).length === 0)) {
                this.showMessageWarning("Please select a inbound of outbound");
            } else {
                let formDatas : FormData = this.getFormData();
                if (this.inboundSelected.id !== undefined) {
                    await this.uploadInboundPicture(formDatas);
                } else {
                    await this.uploadOutboundPicture(formDatas);
                }
                
                this.currFiles = [];
                this.files = [];
                this.inboundSelected = {} as IInbound;
                this.outboundSelected = {} as IOutbound;
            }
        }
    }

    getFormData () : FormData {
        let formData = new FormData();
        for (let file of this.files) {
            const uuid = uuidv4();
            formData.append("files", file, uuid);
        }

        return formData;
    }

    async uploadInboundPicture(formData : FormData) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);
        for (let i in urls) {
            let inboundPicture: IInboundPicture = {
                id: "",
                url: urls[i],
                idCompany: this.companyId,
                idInbound: this.inboundSelected!.id,
                urlBlob: ""
            };
            const id = await this.inboundPictureApi.SaveInboundPicture(inboundPicture);
        }
        this.showMessageInfo(`The pictures has been successfully saved`);
        this.overlay = false;
    }

    async uploadOutboundPicture(formData : FormData) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);
        for (let i in urls) {
            let outboundPicture: IOutboundPicture = {
                id: "",
                url: urls[i],
                idCompany: this.companyId,
                idOutbound: this.outboundSelected!.id,
                urlBlob: ""
            };
            const id = await this.outboundPictureApi.SaveOutboundPicture(outboundPicture);
        }
        this.showMessageInfo(`The pictures has been successfully saved`);
        this.overlay = false;
    }

    async getInbounds() {
        this.overlay = true;
        this.inboundList = await this.inboundApi.GetInboundsCodes(this.companyId);
        this.overlay = false;
    }

    async getOutbounds() {
        this.overlay = true;
        this.outboundList = await this.outboundApi.GetOutboundsCodes(this.companyId);
        this.overlay = false;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
